import React from 'react';
import cn from 'classnames';
import styles from './formField.module.scss';

export interface IProps {
  /**
   * Additional elements or components to be rendered within the FormField, such as inputs, textarea, etc.
   */
  children: React.ReactNode,
  /**
   * Unique identifier for testing purposes
   */
  dataTest?: string,
  /**
   * Additional CSS class for custom styling.
   */
  className?: string,
  /**
   * Specifies whether the field should be displayed in a more compact, narrow layout. Margin Bottom is 0px
   */
  isNarrow?: boolean,
  /**
   *  Indicates whether validation feedback should be displayed. Margin Bottom is 10px
   */
  isValidationFeedback?: boolean,
}

const FormField = ({
  isNarrow = false,
  isValidationFeedback = false,
  className,
  children,
  dataTest = 'formField',
}: IProps) => {
  const classNames = cn(
    styles.formField,
    {
      [styles.isNarrow]: isNarrow,
      [styles.isValidationFeedback]: isValidationFeedback,
    },
    className,
  );

  return (
    <div className={ classNames } data-test={ dataTest }>
      { children }
    </div>
  );
};

export default FormField;
